import { render, staticRenderFns } from "./StateIdentifyRadioButton.vue?vue&type=template&id=35bbce0a"
import script from "./StateIdentifyRadioButton.vue?vue&type=script&lang=js"
export * from "./StateIdentifyRadioButton.vue?vue&type=script&lang=js"
import style0 from "./StateIdentifyRadioButton.vue?vue&type=style&index=0&id=35bbce0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports